import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import useMediaQuery from '@mui/material/useMediaQuery';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import PopUpCustom from 'components/PopupCustom/PopUpCustom';
import { BtnCloseInModal } from 'components/Common/Button';

const CpnResponPerson_new = (props) => {

    const {
        form,
        Option,
        IsRoleDM,
        IsRoleVP,
        nStatusID,
        sMode,
        sTypeResponPerson,
        setsTypeResponPerson,
        sResponPerson,
        setsResponPerson,
        setIsOtherExternalPTT,
        IshaveResponEmp,
        objPermission,
        IsShowAll,
        nHistoryStatusID
    } = props;
    // isEdit
    const Layout1070 = useMediaQuery('(min-width:1070px)');
    const [IsOpenHelper, setIsOpenHelper] = useState(false)

    const [IsView, setIsView] = useState(false)

    useEffect(() => {
        setIsView(nStatusID != 0 && (sMode === "view" || objPermission?.Responsible?.isDisable == true))
    }, [props.nStatusID,sMode])

    const onhandleOpenHelper = () => {
        setIsOpenHelper(!IsOpenHelper)
    }

    return (
        <>
            <Accordion header={"ข้อมูลผู้รับผิดชอบแก้ไข (ข้อมูลใช้ภายนอก)"} isShowHelper={true} onOpenHelper={onhandleOpenHelper}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{marginTop:'-35px'}}>
                    <Grid item xs={12}>
                        <RadioFormItem
                            name="sTypeResponPerson"
                            label="ประเภทผู้รับผิดชอบ"
                            required={true}
                            disable={IsView}
                            options={Option.lstTypeResponPerson ?? []}
                            value={form.getValues("sTypeResponPerson")}
                            row={!Layout1070 ? false : true}
                            onChange={(e) => {
                                setsTypeResponPerson(e);
                                form.setValue("oAutoUnitInGBU", null)
                                form.setValue("oAutoEmpInGBU", null)
                                form.setValue("oAutoUnitInPTT", null)
                                form.setValue("oAutoEmpInPTT", null)
                                form.setValue("oUnitExternalPTT", null)
                                form.setValue("sExternalPTT", null)
                                setIsOtherExternalPTT(false)

                            }}
                        />
                    </Grid>
                    {
                        // หน่วยงานภายนอก ปตท.
                        (form.getValues("sTypeResponPerson") === "24" || sTypeResponPerson === "24")
                            ?
                            <>
                                <Grid item xs={12} sm={6}>
                                    <AutoCompleteSelect
                                        name="oUnitExternalPTT"
                                        options={Option.lstOutPTT ?? []}
                                        label={"หน่วยงาน"}
                                        required={true}
                                        disabled={IsView}
                                        onChange={(event) => {
                                            if (event) {
                                                setIsOtherExternalPTT(event.IsOther === true ? true : false)
                                            }
                                            else {
                                                setIsOtherExternalPTT(false)
                                            }
                                        }}
                                    />
                                </Grid>
                                {
                                    form.getValues("oUnitExternalPTT")?.IsOther == true
                                        ?
                                        <Grid item xs={12} sm={6}>
                                            <InputCustomLabel
                                                id="sExternalPTT"
                                                name="sExternalPTT"
                                                label="หน่วยงาน (อื่นๆ)"
                                                maxLength={250}
                                                required={true}
                                                disabled={IsView}
                                            />
                                        </Grid>
                                        : null
                                }
                            </>
                            :
                            // หน่วยงานใน (CMM, GSM, NGR, NGV)
                            (form.getValues("sTypeResponPerson") === "22" || sTypeResponPerson === "22")
                                ?
                                <>
                                    <Grid item xs={12} style={{ display: [0, 1, 2].includes(nStatusID) || IsShowAll || nHistoryStatusID == 17 ? "" : "none" }}>  {/** จะแสดงแค่ตอนเปิดใบงาน */}
                                        <RadioFormItem
                                            name="sResponPerson"
                                            label="ผู้รับผิดชอบ"
                                            required={true}
                                            options={Option.lstResponPerson ?? []}
                                            value={form.getValues("sResponPerson")}
                                            row={true}
                                            disable={IsView}
                                            onChange={(e) => {
                                                setsResponPerson(e);
                                                form.setValue("oAutoUnitInGBU", null)
                                                form.setValue("oAutoEmpInGBU", null)
                                                form.setValue("oAutoUnitInPTT", null)
                                                form.setValue("oAutoEmpInPTT", null)
                                            }}
                                        />
                                    </Grid>
                                    {
                                        (form.getValues("sResponPerson") === "25" || sResponPerson === "25")
                                            ?
                                            <>
                                                <Grid item xs={12} md={6}>
                                                    <AsyncAutoComplete
                                                        name="oAutoUnitInGBU"
                                                        sUrlAPI={"User/SearchUnitInfo"}
                                                        ParamUrl={{ "nResponsibleTypeID": form.getValues("sTypeResponPerson") }}
                                                        label={"หน่วยงาน"}
                                                        textSearch={"กรอกรหัสหน่วยงาน/ชื่อหน่วยงาน"}
                                                        required={true}
                                                        disabled={IsView}
                                                    />
                                                </Grid>
                                                {
                                                    ((IsRoleDM && [3, 19].includes(nStatusID)) || (IsRoleVP && [19].includes(nStatusID)) || ([5, 7, 20].includes(nStatusID)) || objPermission?.Responsible?.isHaveEmpRespon == true) ?
                                                        <Grid item xs={12} md={6}>
                                                            <AsyncAutoComplete
                                                                name="oAutoEmpInGBU"
                                                                sUrlAPI={"User/SearchEmpPIS"}
                                                                label={"ผู้รับผิดชอบแก้ไข"}
                                                                textSearch={"กรอกรหัสพนักงาน/ชื่อ/นามสกุล"}
                                                                ParamUrl={{ "nResponsibleTypeID": form.getValues("sTypeResponPerson"), "sUnitCode": form.getValues("oAutoUnitInGBU") != null ? form.getValues("oAutoUnitInGBU").value : null }}
                                                                required={true}
                                                                disabled={IsView && objPermission?.Responsible?.isEdit == false}
                                                            />
                                                        </Grid>
                                                        : null
                                                }
                                            </>
                                            :
                                            <>
                                                <Grid item xs={12} md={6}>
                                                    <AsyncAutoComplete
                                                        name="oAutoEmpInGBU"
                                                        sUrlAPI={"User/SearchEmpPIS"}
                                                        label={"ผู้รับผิดชอบแก้ไข"}
                                                        textSearch={"กรอกรหัสพนักงาน/ชื่อ/นามสกุล"}
                                                        ParamUrl={{ "nResponsibleTypeID": form.getValues("sTypeResponPerson"), "sUnitCode": form.getValues("oAutoUnitInGBU") != null ? form.getValues("oAutoUnitInGBU").value : null }}
                                                        required={true}
                                                        disabled={IsView && objPermission?.Responsible?.isEdit == false}

                                                    />
                                                </Grid>
                                            </>
                                    }
                                </>
                                :
                                // กลุ่มตลาด GBU
                                <>
                                    <Grid item xs={12} style={{ display: [0, 1, 2].includes(nStatusID) || IsShowAll || nHistoryStatusID == 17 ? "" : "none" }}>
                                        <RadioFormItem
                                            name="sResponPerson"
                                            label="ผู้รับผิดชอบ"
                                            required={true}
                                            options={Option.lstResponPerson ?? []}
                                            value={form.getValues("sResponPerson")}
                                            row={true}
                                            onChange={(e) => {
                                                setsResponPerson(e);
                                                form.setValue("oAutoUnitInGBU", null)
                                                form.setValue("oAutoEmpInGBU", null)
                                                form.setValue("oAutoUnitInPTT", null)
                                                form.setValue("oAutoEmpInPTT", null)
                                            }}
                                            disable={IsView}
                                        />
                                    </Grid>
                                    {
                                        (form.getValues("sResponPerson") === "25" || sResponPerson === "25")
                                            ?
                                            <>
                                                <Grid item xs={12} md={6}>
                                                    <AsyncAutoComplete
                                                        name="oAutoUnitInPTT"
                                                        label={"หน่วยงาน"}
                                                        textSearch={"กรอกรหัสหน่วยงาน/ชื่อหน่วยงาน"}
                                                        sUrlAPI={"User/SearchUnitInfo"}
                                                        ParamUrl={{ "nResponsibleTypeID": form.getValues("sTypeResponPerson") }}
                                                        required={true}
                                                        disabled={IsView}

                                                    />
                                                </Grid>
                                                {
                                                    ((IsRoleDM && [3, 19].includes(nStatusID)) || (IsRoleVP && [19].includes(nStatusID)) || ([5, 7, 20].includes(nStatusID)) || objPermission?.Responsible?.isHaveEmpRespon == true) ?
                                                    <Grid item xs={12} md={6}>
                                                            <AsyncAutoComplete
                                                                name="oAutoEmpInPTT"
                                                                sUrlAPI={"User/SearchEmpPIS"}
                                                                label={"ผู้รับผิดชอบแก้ไข"}
                                                                textSearch={"กรอกรหัสพนักงาน/ชื่อ/นามสกุล"}
                                                                ParamUrl={{ "nResponsibleTypeID": form.getValues("sTypeResponPerson"), "sUnitCode": form.getValues("oAutoUnitInPTT") != null ? form.getValues("oAutoUnitInPTT").value : null }}
                                                                required={true}
                                                                disabled={IsView && objPermission?.Responsible?.isEdit == false}

                                                            />
                                                        </Grid>
                                                        : null
                                                }
                                            </>
                                            :
                                            <>
                                                <Grid item xs={12} md={6}>
                                                    <AsyncAutoComplete
                                                        name="oAutoEmpInPTT"
                                                        sUrlAPI={"User/SearchEmpPIS"}
                                                        label={"ผู้รับผิดชอบแก้ไข"}
                                                        textSearch={"กรอกรหัสพนักงาน/ชื่อ/นามสกุล"}
                                                        ParamUrl={{ "nResponsibleTypeID": form.getValues("sTypeResponPerson"), "sUnitCode": form.getValues("oAutoUnitInPTT") != null ? form.getValues("oAutoUnitInPTT").value : null }}
                                                        required={true}
                                                        disabled={IsView && objPermission?.Responsible?.isEdit == false}

                                                    />
                                                </Grid>
                                            </>
                                    }
                                </>
                    }
                </Grid>
            </Accordion>
            <PopUpCustom
                setIsOpen={setIsOpenHelper}
                IsOpen={IsOpenHelper}
                sMaxWidth={'sm'}
                JsxDialogHeader={
                    <>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Typography>ข้อมูลเพิ่มเติม</Typography>
                            </Grid>
                            <Grid item>
                                <BtnCloseInModal txt={"ยกเลิก"} onClick={() => { onhandleOpenHelper() }} />
                            </Grid>
                        </Grid>
                    </>
                }
                JsxDialogContent={
                    <>
                        <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item xs={12}>
                                <Typography>- กรณีเลือกประเภทผู้รับผิดชอบเป็น หน่วยงานภายใน (CMM, GSM, NGR, NGV) ผู้ดำเนินการในลำดับถัดไปคือ ผจ.ส่วน ของหน่วยงาน/พนักงานที่ได้รับมอบหมาย</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography>- กรณีเลือกประเภทผู้รับผิดชอบเป็น หน่วยงานภายใน ปตท. และ หน่วยงานภายนอก ปตท. ผู้ดำเนินการในลำดับถัดไปคือ BA Service ผู้เปิดใบงาน</Typography>
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>
    )
}

export default CpnResponPerson_new